import { reasons } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ReasonsSection() {
  return (
    <section id="reasons" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="先弄清楚原因"
          title="为什么韩剧TV会打不开"
          desc="打不开的原因通常集中在下面几类。先对照判断，后续的解决办法会更有针对性，也更容易一次排查到位。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {reasons.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}